// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pmDw","textarea":"styles_textarea__3LDwh"};